import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_SEGMENTS: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetSegments'
);

export const SET_CUSTOMERS: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetCustomers'
);

export const SET_AGENTS: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetAgents'
);

export const SET_PRODUCT_BASIC_INCO: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetProductBasicInfo'
);

export const UPDATE_PRODUCT_BASIC_INFO: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'UpdateProductBasicInfo'
);

export const UPDATE_DESCRIPTION_TEMPORARY: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'UpdateDescriptionTemporary'
);

export const UPDATE_NAME_TEMPORARY: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'UpdateNameTemporary'
);

export const SET_SPECIFICATIONATTRIBUTE_LIST: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetSpecificationAttributeList'
);

export const SET_SPECIFICATIONATTRIBUTE_LIST_NO_AMENTITIES: string =
  typeCreatorV2(
    'PropertyBasicInfoReducer',
    'SetSpecificationAttributeListNoAmentities'
  );

export const GET_LIST_PRICE_TYPE: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'GetListPriceType'
);

export const GET_LIST_ZONES: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'GetListZones'
);

export const SET_CLIENT_CUSTOMERS: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'GetClientCustomers'
);

export const FETCH_ROLES: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'FetchRoles'
);

export const ADD_CUSTOMER: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'AddCustomer'
);

export const SET_CLIENTS_MINI_PROFILES: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetClientsMiniProfiles'
);

export const SET_AGENTS_CUSTOMER: string = typeCreatorV2(
  'PropertyBasicInfoReducer',
  'SetAgentsCustomer'
);
